module.exports = __webpack_public_path__ + "img/report-anti-vice.5c537cdb.5c537cdb.png";